// eslint-disable-next-line import/prefer-default-export
export const ROUTES_WITH_TRANSPARENT_BACKGROUND = ['GetStarted', 'Checkout'];
